//

import request from '@/utils/request';

export function getOperationLogList(params: any) {
  return request({
    url: 'Log/operationLogList',
    method: 'get',
    params
  });
}
